import { useState, useEffect, RefObject } from 'react';

export const useDetectOutsideClick = (
  elements: RefObject<any>[],
  initialState: boolean
): [boolean, (active: boolean) => void] => {
  const [isActive, setIsActive] = useState<boolean>(initialState);

  useEffect(() => {
    // Handle outside click
    const clickEvent = (event: Event): any => {
      const nullElements = elements.filter((e) => e.current === null);

      // Check if element exist and contains target
      if (nullElements.length) {
        return;
      }

      const clickedElements = elements.filter((element) =>
        element.current.contains(event.target)
      );

      if (!clickedElements.length) {
        setIsActive(false);
      }
    };

    // Event listener
    if (isActive) {
      globalThis.addEventListener('click', clickEvent, true);
    }

    return () => {
      globalThis.removeEventListener('click', clickEvent, true);
    };
  }, [isActive, elements]);

  return [isActive, setIsActive];
};
